export const isInIntlBrowser = /intlbrowser/i.test(navigator.userAgent);
export const IsTest = location.origin.includes("test") || location.origin.includes('localhost');
